import { UserManager, WebStorageStateStore } from 'oidc-client-ts';
import { keycloak } from '../config.json';

export function createUserManager(redirectUri?: string) {
  return new UserManager({
    ...keycloak.clientConfig,
    redirect_uri: redirectUri || '',
    post_logout_redirect_uri: `${window.location.origin}/login?logout=true`,
    userStore: new WebStorageStateStore({ store: window.localStorage }),
  });
}

export function parseJwt(token: string) {
  var base64Url = token.split('.')[1];
  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  var jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join('')
  );

  return JSON.parse(jsonPayload);
}
